import React from 'react';
import { Redirect } from 'react-router'
import {apiGet} from "../services/apiClient";

export default class Home extends React.Component {
    componentDidMount() {
        apiGet('user/company')
            .then(data => {
                this.setState({ showNewParcelForm: !data || data.showNewParcelForm });
            });
    }

    render() {
        return this.state ? <Redirect to={`/parcels/list${this.state.showNewParcelForm ? '/new' : ''}`} /> : null;
    }
};


// WEBPACK FOOTER //
// ./App/pages/home.jsx